//import http from "../http";
import http from "../../../http";


const FlightPlanningService =
        {

          getJsonData: async (FKey1, TableCode) => {
              const jsondata = await http.instance.get("/TechnicalHistory/JsonData/", {
                  params: {
                      FKey1: FKey1,
                      TableCode: TableCode
                         }
            })
                    return jsondata.data;
             },  // bu kalıyor ....


      /*  GetAdvanceSearch: async (form) => {
            const searchFlights = await http.instance.post("/Flights/AdvancedSearch", form);
            return searchFlights.data;
        }  */

    };
export default FlightPlanningService;
